<div class="body-loader" *ngIf="isLoading | async">
<div class="lds-ripple"><div></div><div></div></div>
</div>